/** Input types that take no typed text, so editor shortcuts stay live while they have focus. */
const NON_TEXT_INPUT_TYPES = new Set([
  "range",
  "checkbox",
  "radio",
  "button",
  "submit",
  "reset",
  "color",
  "file",
  "image",
]);

/** Keys a focused slider uses itself (step, jump to min/max). */
const SLIDER_KEYS = new Set(["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "Home", "End", "PageUp", "PageDown"]);

export interface FocusTarget {
  tagName: string;
  type?: string;
  isContentEditable?: boolean;
}

/**
 * True when the focused element should get this key instead of the keymap.
 * Text fields take every key. A focused slider keeps only its own navigation keys,
 * so tool keys (E, R, B, …) still work after dragging a slider.
 */
export function focusOwnsKey(target: FocusTarget | null, code: string): boolean {
  if (!target) return false;
  if (target.isContentEditable) return true;
  const tag = target.tagName.toUpperCase();
  if (tag === "TEXTAREA" || tag === "SELECT") return true;
  if (tag !== "INPUT") return false;
  const type = (target.type ?? "text").toLowerCase();
  if (type === "range") return SLIDER_KEYS.has(code);
  return !NON_TEXT_INPUT_TYPES.has(type);
}
